import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

// A custom hook that builds on useLocation to parse
// the query string for you.
const useQueryParams = () => {
  const { search } = useLocation();

  return useMemo(() => queryString.parse(search), [search]);
};

export default useQueryParams;
